import React from 'react';
import en from '../../international/translations/en';

const PerksFooter = () => (<div className="perks-footer">{en.perks.footer_text}</div>);
export default PerksFooter;
